import { useGetEnvironment } from 'stores/rq/environment';
import { useGetBlueprint } from 'stores/rq/blueprints';
import type { VcsApi } from '@env0/vcs-service/api';
import isNil from 'lodash/isNil';
import type { BlueprintApi } from '@env0/blueprint-service/api';

export function getVcsType(template?: BlueprintApi.Blueprint): VcsApi.VcsType | undefined {
  if (isNil(template)) return;

  const {
    githubInstallationId,
    isBitbucketServer,
    isGitLabEnterprise,
    isGitHubEnterprise,
    isGitLab,
    isAzureDevOps,
    bitbucketClientKey
  } = template;

  if (githubInstallationId) return 'GitHub';
  else if (bitbucketClientKey) return 'BitBucket';
  else if (isGitLab) return 'GitLab';
  else if (isAzureDevOps) return 'AzureDevOps';
  else if (isGitHubEnterprise) return 'GitHubEnterprise';
  else if (isBitbucketServer) return 'BitBucketServer';
  else if (isGitLabEnterprise) return 'GitLabEnterprise';
  else return 'OtherVcs';
}

export const useGetVcsDetails = (environmentId?: string) => {
  const { isLoading: isGetEnvironmentLoading, data: environment } = useGetEnvironment(environmentId);

  const { isLoading: isGetBlueprintLoading, data: template } = useGetBlueprint(
    environment?.latestDeploymentLog?.blueprintId
  );

  return {
    vcsType: getVcsType(template),
    templateType: template?.type,
    repositoryUrl: environment?.latestDeploymentLog?.blueprintRepository,
    isLoading: isGetEnvironmentLoading || isGetBlueprintLoading
  };
};
